import { Location } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SiteDataService } from '@app/shared/services/site-data';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, SubscriptionLike, map } from 'rxjs';
import { Store, select } from '@ngrx/store';
import * as InputsStore from '@app/shared/store/inputs';
import { filterNotNullish } from '@app/core/utils/rxjs';

@Component({
	selector: 'app-footer',
	templateUrl: 'footer.component.html',
	styleUrls: ['footer.component.scss'],
})
export class FooterComponent implements OnDestroy {
	public readonly pageLoaded$ = this._uiState.pipe(
		select(InputsStore.selectors.selectProp('pageLoaded')),
		filterNotNullish()
		// filter(pageLoaded => pageLoaded),
		// first(),
		// tap(_ => console.log('footer: pageLoaded'))
	);

	public readonly siteData$ = this.siteData.siteData$;

	public readonly isStandalonePage$ = new BehaviorSubject(false);

	private _subscriptions: SubscriptionLike[] = [];

	constructor(private siteData: SiteDataService, private _location: Location, private _router: Router, private _translate: TranslateService, private _uiState: Store<InputsStore.State>) {
		this._subscriptions.push(
			this._router.events.subscribe(event => {
				if (event instanceof NavigationEnd) {
					const locationPath = this._location.path();
					this.isStandalonePage$.next(locationPath.startsWith('/hu/visszaru') || locationPath.startsWith('/en/parcel-return'));
				}
			})
		);
	}

	ngOnDestroy(): void {
		this._subscriptions.forEach(subscription => subscription.unsubscribe());
	}
}
